export const UrlConstants = {
    root: '/',
    index: '/index',
    incident: {
        incident: '/incident/incident',
        alert: '/incident/alert'
    },
    service: {
        list: '/service/list',
        detail: '/service/detail',
        new: '/service/new'
    },
    escalation: '/escalation',
    schedule: {
        list: '/schedule/list',
        detail: '/schedule/detail',
        new: '/schedule/new',
        edit: '/schedule/edit',
        copy: '/schedule/copy'

    },
    integration: {
        list: '/integration/list',
        detail: '/integration/detail',
        new: '/integration/new'
    },
    extension: {
        list: '/extension/list',
        new: '/extension/new',
        edit: '/extension/edit',
        copy: '/extension/copy'
    },
    changehistory: '/change-history/list',
    notihistory: '/noti-history/list',
    team: '/team/list',
    user: {
        list: '/user/list',
        detail: '/user/detail'
    },
    notitemplate: {
        list: '/an/noti-template/list'
    },
    analytics: {
        system: '/an/analytics/system',
        sysview: '/an/analytics/sysview',
        incident: '/an/analytics/incident',
        inctview: '/an/analytics/inctview',
        notification: '/an/analytics/notification',
        notiview: '/an/analytics/notiview',
        user: '/an/analytics/user'
    },
    personalsetting: {
        myinformation: '/personalsetting/my-information',
        additionalsetting: '/personalsetting/additional-setting',
        basicinformation: '/personalsetting/basic-information',
        notificationrule: '/personalsetting/notification-rule'
    },
    guide: '/guide',
    contents: {
        index: '/contents'
    },
    notice: {
        list: '/notice/list',
        detail: '/notice/detail'
    },
    profile: '/profile',

    error: {
        notfound: '/error/404',
        server: '/error/500'
    },
    runbook: {
        template: '/runbook/template',
        credential: '/runbook/credential',
        history: '/runbook/runbook-history',
    },
    sendnotice: '/sendnotice/sendnotice',
};



// WEBPACK FOOTER //
// ./src/app/shared/constants/src/url.constants.ts